// extracted by mini-css-extract-plugin
export var gradient = "AllInOneSolutions-module--gradient--7ac2f";
export var left = "AllInOneSolutions-module--left--249ff";
export var linkText = "AllInOneSolutions-module--link-text--dede9";
export var linkWrapper = "AllInOneSolutions-module--link-wrapper--07f14";
export var right = "AllInOneSolutions-module--right--05939";
export var solgradient = "AllInOneSolutions-module--solgradient--4245c";